// @ts-nocheck
if(!customElements.get('product-image-uploader')) {
    class ProductImageUploader extends HTMLElement {
        constructor() {
            super();
            this.accessToken = 'A4eFAVk3UQqAMKun5HJQDz';
            this.fileStack = null;
            this.aspectRatio = [
                {
                    handle: 'square',
                    value: 1 / 1
                    
                },
                {
                    handle: 'landscape',
                    value: 3 / 2
                },
                {
                    handle: 'panoramic',
                    value: 2 / 1
                },
                {
                    handle: 'portrait',
                    value: 2 / 3
                }
            ];
            this.selectedAspectRatio = [];
            this.editFileHandle = null;
            this.picker = null;
            this.uploadedImage = null;
            this.imagePreview = null;
            this.orientationHandle = null;
            this.uploadedFileName = null;
            this.uploadedFileSize = null;
        }
        connectedCallback() {
            this.fileStackConnect = filestack.init(this.accessToken);
            this.selectors = {
                optionsOrientation: document.querySelector('[data-option-handle="orientation"] input:checked'),
                imageUploaded: document.querySelector('[ref="image_uploaded"]'),
                imagePreview: document.querySelector('[ref="image_preview"]'),
                pickerBtn: document.getElementById('picker'),
                undoneUploaded: document.querySelector('product-image-uploader .completed .tap-to-undone svg'),
                imageUploaderRequired: document.querySelector('.image-upload-required button'),
                orientationInputs: document.querySelectorAll('[data-option-handle="orientation"] input')
            }
            if(this.selectors.optionsOrientation) {
                this.orientationHandle = this.selectors.optionsOrientation.value.toLowerCase();
                this.selectedAspectRatio = this.aspectRatio.filter(ratio => this.orientationHandle.includes(ratio.handle));
            } else {
                this.selectedAspectRatio = this.aspectRatio.filter(ratio => this.dataset.orientation.includes(ratio.handle));
            }
            this.initPicker();
            
            this.selectors.pickerBtn.addEventListener('click', event => {
                event.preventDefault();
                this.picker.open();
            });
            if(this.selectors.undoneUploaded) {
                this.selectors.undoneUploaded.addEventListener('click', () => {
                    this.deleteUploadedFile();
                })
            }
            if(this.selectors.imageUploaderRequired) {
                this.selectors.imageUploaderRequired.addEventListener('click', ()=> {
                    const productImageUploader = this.selectors.imageUploaderRequired.closest('product-image-uploader');
                    productImageUploader && productImageUploader.classList.remove('required');
                })
            }
            this.onVariantIdChangedUnsubscriber = subscribe(
                PUB_SUB_EVENTS.variantIdChanged,
                this.variantChanged.bind(this)
            );
        }
        deleteUploadedFile() {
            const productImageUploader = this.selectors.undoneUploaded.closest('product-image-uploader');
            productImageUploader && productImageUploader.classList.remove('done');
            const index = PUB_SUB_ORIENTATION.findIndex(
                o => o.orientation === this.orientationHandle
            );
            if (index !== -1) {
                PUB_SUB_ORIENTATION.splice(index, 1);
            }
        }
        clearUploadedFile() {
            const productImageUploader = this.selectors.undoneUploaded.closest('product-image-uploader');
            productImageUploader && productImageUploader.classList.remove('done');
            this.selectors.imageUploaded && (this.selectors.imageUploaded.value = '');
            this.selectors.imagePreview && (this.selectors.imagePreview.value = '');
        }
        variantChanged({ data: { event }}) {
            if(event.target.closest('[data-option-handle="orientation"]')) {
                this.orientationHandle = event.target.value.toLowerCase();
                this.selectedAspectRatio = this.aspectRatio.filter(ratio => this.orientationHandle.includes(ratio.handle));
                this.initPicker();  
                this.clearUploadedFile();
                const existing = PUB_SUB_ORIENTATION.find(o => o.orientation === this.orientationHandle);
                if(existing) {
                    this.classList.add('done');
                    const fileName = this.querySelector('.completed .file-name');
                    fileName && (fileName.innerText = `${existing.uploadedFileName}`);
                    const fileSize = this.querySelector('.completed .file-size');
                    fileSize && (fileSize.innerText = `${existing.uploadedFileSize}`);
                    this.selectors.imageUploaded && (this.selectors.imageUploaded.value = existing.uploadedImage);
                }
            }
        }
        initPicker() {
            this.picker = null;
            const options = {
                fromSources: ["local_file_system"],
                accept: ['image/jpeg', 'image/png'],
                maxFiles: 1,
                transformations: {
                    crop: {
                        force: true,
                        aspectRatio: this.selectedAspectRatio[0].value
                    }
                },
                onUploadDone: (res) => {
                    this.classList.add('done');
                    const fileName = this.querySelector('.completed .file-name');
                    fileName && (fileName.innerText = `${res.filesUploaded[0].filename}`);
                    const fileSize = this.querySelector('.completed .file-size');
                    const fileSizeMb = parseFloat(res.filesUploaded[0].size) / 1048576;
                    fileSize && (fileSize.innerText = `${fileSizeMb.toFixed(1)} MB`);
                    this.uploadedImage = res.filesUploaded[0].url;
                    this.uploadedFileName = `${res.filesUploaded[0].filename}`;
                    this.uploadedFileSize = `${fileSizeMb.toFixed(1)} MB`;
                    publish(PUB_SUB_EVENTS.canvasImageUploaded, {
                        data: {
                         result: res.filesUploaded[0].url,
                         orientation: this.orientationHandle
                        },
                    });
                    const borderWrap = document.querySelector('[ref="border_option"]');
                    const existing = PUB_SUB_ORIENTATION.find(o => o.orientation === this.orientationHandle);
                    if(existing) {
                        existing.uploadedImage = this.imageUploaded;
                        existing.uploadedFileName = this.uploadedFileName;
                        existing.uploadedFileSize = this.uploadedFileSize;
                        existing.borderWrap = borderWrap ? borderWrap.value : 'Mirror Wrap'
                    } else {
                        PUB_SUB_ORIENTATION.push({
                            orientation: this.orientationHandle,
                            uploadedImage: this.uploadedImage,
                            uploadedFileSize: this.uploadedFileSize,
                            uploadedFileName: this.uploadedFileName,
                            borderWrap: borderWrap ? borderWrap.value : 'Mirror Wrap'
                        });
                    }
                    const reExisting = PUB_SUB_ORIENTATION.find(o => o.orientation === this.orientationHandle);
                    if(reExisting) {
                        this.selectors.imageUploaded && (this.selectors.imageUploaded.value = reExisting.uploadedImage);
                    }
                }
            };

            this.picker = this.fileStackConnect.picker(options);
        }
    }
    customElements.define('product-image-uploader', ProductImageUploader);
}